import type { SWRConfiguration } from "swr";
import { GetHelpTopicByIdRequest, GetHelpTopicByIdResponse, HelpTopic } from "src/api/Tmd.dtos";
import useBaseLoadById from "../useBaseLoadById";
const useHelpTopicById = (
    id?: number | null,
    configuration?: SWRConfiguration<GetHelpTopicByIdResponse, GetHelpTopicByIdResponse> | null,
) =>
    useBaseLoadById<HelpTopic, GetHelpTopicByIdResponse, GetHelpTopicByIdRequest>(
        GetHelpTopicByIdRequest,
        id,
        configuration,
    );
export default useHelpTopicById;
